// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iT","advertCardFooter__row":"c-a_iU","advertCardFooter__name":"c-a_iV","advertCardFooter__price":"c-a_iW","advertCardFooter__age":"c-a_iX"};